import { afterNextRender, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { CfgARAccountModel } from '../../../../models/accountsReceivable/cfg-ar-account.model';
import { dataARLedger, enumValidValueItem } from '../../_models/ar.models';
import { DataARPaymentModel } from '../../../../models/accountsReceivable/data-ar-payment.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ARService } from '../../ar.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Globals } from '../../../../globals';
import { DataARLedgerListModel } from '../../models/data-ar-ledger-list.model';
import { TdoTableV2Component } from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { TdoTableFooterDataModel } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import { CreatePaymentModel } from '../../models/create-payment.model';
import { InsuranceCompanyListModel } from '../../models/insurance-company-list.model';
import { DataARClaimListModel } from '../../models/data-ar-claim-list';
import { TdoTableSelectionEvent } from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { UiService } from '../../../../services/ui.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CreateLedgerItemForPaymentModel } from '../../models/create-ledger-item-for-payment.model';
import { PaymentMethodConfigurationService } from '../../../configuration/payment-method-configuration/payment-method-configuration.service';
import { LocalStorageService } from '../../../../services/local-storage.service';
import { CfgARPaymentMethodModel } from '../../../../models/accountsReceivable/cfg-ar-payment-method';
import { CfgARPaymentProcessorModel } from '../../../../models/accountsReceivable/cfg-ar-payment-processor.model';
import { ArInsurancePaymentOverpayConfirmComponent } from '../ar-insurance-payment-overpay-confirm/ar-insurance-payment-overpay-confirm.component';
import { InsurancePaymentOverpayListModel } from '../../models/insurance-payment-overpay-list.model';
import { DataARLedgerModel } from '../../../../models/accountsReceivable/data-ar-ledger.model';
import { Constants } from '../../../../constants';
import {
  PaymentProcessorConfigurationService
} from '../../../configuration/payment-processor-configuration/payment-processor-configuration..service';
import { PaymentAmountForDoctorModel } from '../../models/payment-amount-for-doctor.model';
import { DataDoctorArPaymentProcessorModel } from '../../../../models/accountsReceivable/data-doctor-ar-payment-processor.model';
import {
  ArInsurancePaymentProcessorTotalConfirmComponent
} from '../ar-insurance-payment-processor-total-confirm/ar-insurance-payment-processor-total-confirm.component';
import { DataARClaimItemListModel } from '../../models/data-ar-claim-item-list';
import { DialogService } from '../../../../services/dialog.service';
import { PAYMENT_SOURCE } from 'src/app/models/constants/payment-source.model';
import { ConversionUtilities } from 'src/app/utilities/conversion.utilities';
import { TdoSelectDialogComponent } from 'src/app/tdo-controls/common/tdo-select-dialog/tdo-select-dialog/tdo-select-dialog.component';
import { EnumARPaymentType } from 'src/app/models/enum/enum-ar-payment-type';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';
import { TdoOrganizerSlideshowDialogComponent } from 'src/app/main-interface/organizer/dialogs/tdo-organizer-slideshow-dialog/tdo-organizer-slideshow-dialog.component';
import { FileManagerService } from 'src/app/modules/file-manager/file-manager.service';
import { DocumentUploadModel } from 'src/app/models/document/document-upload.model';
import { DocumentClassEnum } from 'src/app/models/enum/document/document-class.enum';
import { DocumentTypeEnum } from 'src/app/models/enum/document/document-type.enum';
import { DocumentGroupCreationModel } from 'src/app/models/document/document-group-creation.model';
import { SignalrService } from 'src/app/services/socket/signalr.service';
import { InsurancePaymentActionEnum } from 'src/app/models/enum/ledger/insurance-payment-action.enum';
import { firstValueFrom, forkJoin, of, Observable, ReplaySubject } from 'rxjs';
import { share, map, catchError } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-ar-insurance-payment',
  templateUrl: './ar-insurance-payment.component.html',
  styleUrls: ['./ar-insurance-payment.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArInsurancePaymentComponent implements OnInit, OnDestroy {

  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
  searchPredicate: (data: any, filter: string) => boolean;
  footerData: TdoTableFooterDataModel[] = [];

  arAccounts: CfgARAccountModel[] = [];
  paymentMethods: CfgARPaymentMethodModel[] = [];
  insuranceCompanyList: InsuranceCompanyListModel[] = [];
  insuranceName: string;
  paymentActions: any[] = [];
  paymentCCSources: any[] = [];
  paymentESources: any[] = [];
  ledgerItems: dataARLedger[] = [];
  claims: DataARClaimListModel[] = [];
  claimsRows: DataARClaimListModel[] = [];
  selectedPaymentMethod: CfgARPaymentMethodModel;
  selectedEPaymentType: enumValidValueItem;
  selectedCCPaymentType: enumValidValueItem;
  selectedARAccount: CfgARAccountModel;
  selectedInsuranceCompany: InsuranceCompanyListModel;
  currentARPayment: DataARPaymentModel;
  currentTransactionSetupID: string;
  showOnlyCurrentPatient: boolean = false;
  currentPatientID: string;
  currentPatientName: string;
  currentWorkStationID: string;
  paymentProcessors: CfgARPaymentProcessorModel[] = [];
  insuranceOverPayDistributionList: InsurancePaymentOverpayListModel[] = [];
  insuranceClaimItemOverPayDistributionList: InsurancePaymentOverpayListModel[] = [];

  dataDoctorARPaymentProcessorsAll: DataDoctorArPaymentProcessorModel[] = [];
  dataDoctorARPaymentProcessors: DataDoctorArPaymentProcessorModel[] = [];
  currentDataDoctorARPaymentProcessor: DataDoctorArPaymentProcessorModel;
  currentDataDoctorARPaymentProcessorId: string;

  DocPaymentProcessors: CfgARPaymentProcessorModel[] = [];
  currentPaymentProcessorId: string;
  PaymentAmountForDoctors: PaymentAmountForDoctorModel[];

  claimExpanded: string;

  messagingSubscription: any;
  chargePaymentAmount: boolean = false;
  isLoading: boolean = true;
  isClaimsLoading: boolean = false;
  searchWasEmpty = null;
  paymentAmount: number = 0;
  paymentAmountNotDistributed: number = 0;
  paymentDescription: string;
  datePostPayment: Date;
  dateReceivedPayment: Date;
  datePostPaymentMin: Date;
  showSaveButton: boolean = false;

  enumPaymentTypeE: string = '00000080-1000-0000-0000-000000000003';
  enumCurrencyUSD: string = '00000192-1000-0000-0000-000000000001';
  enumPaymentTransactionTypeIDPurchase: string = '00000277-1000-0000-0000-000000000001';
  enumLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';
  enumLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
  enumLedgerItemStatusOutstanding: string = '00000083-1000-0000-0000-000000000001';
  enumARDistribItemStatusVoid: string = '00000535-1000-0000-0000-000000000002';


  searchInput: string = '';
  searchTimer: any;
  searchTerm: string = 'nosearch';
  searchTermValPay: string = '';
  delaySearch: boolean = true;
  includeClosed: boolean = false;
  pageModeType: string = '';
  isClaimRefusal: boolean = false;
  claimTotalNumber: number = 0;
  changesMade: boolean;
  showClosedClaims: boolean = false;
  isPaymentProcessing: boolean = false;
  isProcessPaymentInProgress: boolean = false;
  isSelectingInsurace: boolean = false;
  insuranceDocuments: any[] = [];
  insuranceDocumentTags: any[] = [];
  selectedDocumentTag: string = '';
  selectedDocumentDescription: string;
  isDisabledReceivedDate: boolean;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ArInsurancePaymentComponent>,
    private readonly uiService: UiService,
    private readonly arService: ARService,
    private readonly ppService: PaymentProcessorConfigurationService,
    private readonly currencyPipe: CurrencyPipe,
    private readonly dialog: MatDialog,
    private readonly globals: Globals,
    private readonly changeDet: ChangeDetectorRef,
    private readonly paymentMethodConfigService: PaymentMethodConfigurationService,
    private readonly localStorageService: LocalStorageService,
    private readonly dialogService: DialogService,
    public datePipe: DatePipe,
    private readonly signalrService: SignalrService,
    private readonly fileService: FileManagerService
  ) {
    this.searchPredicate = (ledgerData: DataARLedgerListModel, filter: string) => {
      if (ledgerData.dataARTransactionItem) {
        return ledgerData.dataARTransactionItem.Code.toLowerCase().includes(filter)
          || ledgerData.Description.toLowerCase().includes(filter);
      }
      return ledgerData.Description.toLowerCase().includes(filter);
    };

    afterNextRender(() => {
      this.init();
    });
  }

  ngOnDestroy(): void {
    if (this.messagingSubscription) {
      this.messagingSubscription.unsubscribe();
      this.messagingSubscription = null;
    }
  }

  ngOnInit() {
    // //console.log('ArInsurancePaymentComponent ngOnInit isloading true');
    this.isLoading = true;
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.cancelClicked();
      }
    });
    this.datePostPayment = new Date();
    this.dateReceivedPayment = new Date();
    this.showOnlyCurrentPatient = true;

    // current patient
    if (this.globals.currentPatientId) {
      this.currentPatientID = this.globals.currentPatientId;
      if (this.globals.ThePatient?.dataContact) {
        this.currentPatientName = this.globals.ThePatient.dataContact.FirstName + ' ' + this.globals.ThePatient.dataContact.LastName;
      }
    }
    if (this.messagingSubscription == null) {
      this.messagingSubscription = this.signalrService.messageUser.subscribe((res) => {
        if (res.messageType == SignalrService.UPDATE_INSURANCE_DOCUMENTS && res.message && res.message['patientId'] === this.currentPatientID) {
          if (res.message['uploadedDocumentId']) {
            this.createInsuranceDocumentGroup(res.message['uploadedDocumentId'], this.globals.currentPatientId).then((result: any) => {
              this.reloadDocuments();
            });
          }
          else
            this.reloadDocuments();
        }
      });
    }
  }

  reloadDocuments() {
    this.getInsuranceDocuments().then((result: any) => {
      this.insuranceDocuments = result.documents;
      this.insuranceDocumentTags = result.tags;
      this.changeDet.detectChanges();
    });
  }

  init() {
    this.currentWorkStationID = this.localStorageService.currentUserData.authdata.WorkStationID;
    const locid = localStorage.getItem('LOCID');

    const promises = [
      firstValueFrom(this.paymentMethodConfigService.getPaymentMethodList(locid)),
      this.getAllInsuranceOrganizationsForCurrentPatient(),
      this.getAllDoctorARLocations(),
      this.getEnumValidValueItemsByValidValueName('enumARInsurancePaymentAction'),
      firstValueFrom(this.ppService.getValPayPaymentProcessorARLocList()),
      this.getInsuranceDocuments()
      // claims
    ];

    // //console.log('ArInsurancePaymentComponent init isloading true');
    this.isLoading = true;
    Promise.all(promises).then((results: any[]) => {
      // //console.log('ArInsurancePaymentComponent init results:', results);
      this.paymentMethods = results[0];
      this.insuranceCompanyList = results[1];
      this.arAccounts = results[2];
      this.paymentActions = results[3];
      this.dataDoctorARPaymentProcessorsAll = results[4];
      this.insuranceDocuments = results[5].documents;
      this.insuranceDocumentTags = results[5].tags;

      // load default insurance claims
      // //console.log('init showOnlyCurrentPatient', this.showOnlyCurrentPatient);
      // //console.log('init data', this.data);
      // //console.log('init this.data?.type?.length', this.data?.type?.length);
      if (this.showOnlyCurrentPatient && !this.data?.type) {
        ////console.log('showOnlyCurrentPatient, load claims');
        this.setAndLoadClaimsForDefaultPatientInsurance();
        // LoadClaimsForInsurance will set isLoading = false when done
      } else if (this.data?.type) {
        // insurance claim refusal
        this.pageModeType = this.data.type;
        if (this.pageModeType === 'insurance-claim-refusal') {
          this.loadClaimRefusal();
        }
        // //console.log('ArInsurancePaymentComponent init isloading false');
        this.isLoading = false;
      } else {
        // //console.log('ArInsurancePaymentComponent init isloading false');
        this.isLoading = false;
      }
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      // //console.log('ArInsurancePaymentComponent init error isloading false');
      this.isLoading = false;
    });
  }

  searchChanged(change: any) {
    let passedValue: string = '';

    // if there is already a timer running, then stop
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    if (change.target.value) {
      passedValue = change.target.value;
    }

    // trigger the search action after 800 mls
    this.searchTimer = setTimeout(() => this.searchClaims(passedValue), 1000);
  }

  searchClaims(searchTerm: string) {
    // holder for search results
    let searchResults: DataARClaimListModel[] = [];
    const searchResultsLocal: DataARClaimListModel[] = [];
    this.claimsRows = [];
    this.isClaimsLoading = true;

    // if we have a search string
    if (searchTerm.length) {

      this.claims.forEach(a => {
        if (a.PatientFirstName?.toUpperCase().includes(searchTerm.toUpperCase())
          || a.PatientLastName?.toUpperCase().includes(searchTerm.toUpperCase())
          || (a.PatientFirstName + ' ' + a.PatientLastName).toUpperCase().includes(searchTerm.toUpperCase())
          || a.TDOClaimNumber && a.TDOClaimNumber.toString() === searchTerm) {
          searchResultsLocal.push(a);
        }
      });

      this.claimsRows = [].concat(searchResultsLocal);
      this.changeDet.detectChanges();

      // if looking for closed claims
      if (this.includeClosed) {
        // go to server for closed matches
        this.searchTerm = searchTerm;
        if (searchTerm.trim() === '') {
          this.searchTerm = 'nosearch';
        }

        let InsuranceID = Constants.emptyGuid;
        let OrganizationID = Constants.emptyGuid;

        if (this.selectedInsuranceCompany?.InsuranceID) { InsuranceID = this.selectedInsuranceCompany.InsuranceID; }
        else if (this.selectedInsuranceCompany?.OrganizationID) { OrganizationID = this.selectedInsuranceCompany.OrganizationID; }

        const promises = [
          this.getAllClaimsWithItems(InsuranceID, OrganizationID)
        ];

        Promise.all(promises).then((results: any[]) => {
          searchResults = results[0];
          if (!this.includeClosed) {
            // filter out zero balance claims
            // this.claimsRows = this.claimsRows.filter(a => a.ClaimAmountOutstanding > 0);
          }
          this.claimsRows = [].concat(searchResults).concat(this.claimsRows);
          this.changeDet.detectChanges();
          this.isClaimsLoading = false;
        }, err => {
          this.createMessage('Something went wrong', 'Error');
          this.isClaimsLoading = false;
        });
      }
      else {
        this.isClaimsLoading = false;
      }
    }
    else {
      // search term is blank
      this.claimsRows = [].concat(this.claims);
      this.isClaimsLoading = false;
    }
  }

  createDataARPaymentRecord() {
    const promise = new Promise((resolve, reject) => {

      const createPayment = new CreatePaymentModel();
      if (this.datePostPayment.getDate() !== new Date().getDate())
        this.datePostPayment.setUTCHours(12, 0, 0, 0);
      createPayment.datePostPayment = this.datePostPayment;
      if (this.dateReceivedPayment.getDate() !== new Date().getDate())
        this.dateReceivedPayment.setUTCHours(12, 0, 0, 0);
      createPayment.dateReceivedPayment = this.dateReceivedPayment;
      createPayment.Description = this.paymentDescription;
      createPayment.enumPaymentSourceID = PAYMENT_SOURCE.Insurance;
      createPayment.DepositARAccountID = this.selectedARAccount.ARAccountID;

      if (this.selectedInsuranceCompany.InsuranceID === Constants.emptyGuid) {
        createPayment.PaymentSourceObjectID = this.selectedInsuranceCompany.OrganizationID;
        createPayment.PatientID = null;
      }
      else {
        createPayment.PaymentSourceObjectID = this.selectedInsuranceCompany.InsuranceID;
        createPayment.PatientID = this.globals.currentPatientId;
      }
      createPayment.paymentAmount = this.paymentAmount;
      createPayment.enumCurrencyID = this.enumCurrencyUSD;
      // createPayment.PatientID = this.globals.currentPatientId; // may need to set this to null for a bulk insurance payment
      createPayment.LOCID = this.globals.LOCID;
      createPayment.enumPaymentTransactionTypeID = this.enumPaymentTransactionTypeIDPurchase;
      if (this.selectedPaymentMethod) {
        createPayment.enumARPayementCCTypeID = this.selectedPaymentMethod.enumARPayementCCTypeID ? this.selectedPaymentMethod.enumARPayementCCTypeID : null;
        createPayment.enumARPayementETypeID = this.selectedPaymentMethod.enumARPayementETypeID ? this.selectedPaymentMethod.enumARPayementETypeID : null;
        createPayment.enumARPayementTypeID = this.selectedPaymentMethod.enumARPayementTypeID ? this.selectedPaymentMethod.enumARPayementTypeID : null;
      }

      this.arService.createDataARPaymentRecord(createPayment)
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  setPaymentAmountDistributionRemaining() {
    let paymentsDistributed = 0;
    this.claims.forEach(claim => {
      paymentsDistributed += claim.ApplyPayment;
    });

    // //console.log('setPaymentAmountDistributionRemaining paymentsDistributed:', paymentsDistributed);
    this.paymentAmountNotDistributed = ConversionUtilities.roundDecimal(this.paymentAmount - paymentsDistributed);
    // //console.log('setPaymentAmountDistributionRemaining paymentAmountNotDistributed:', this.paymentAmountNotDistributed);
    if (this.paymentAmountNotDistributed < 0)
      this.createMessage('Amount distributed is more than the total payment amount.', 'Error');
  }

  createMessage(message: string, type: string) {
    this.uiService.displayMessage(type, message);
  }

  getEnumValidValueItemsByValidValueName(ValidValueName: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getEnumValidValueItemsByValidValueName(ValidValueName)
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  getAllClaimsWithItems(InsuranceID: string, OrganizationID: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllClaimsWithItems(InsuranceID, OrganizationID, this.includeClosed, this.searchTerm, this.showOnlyCurrentPatient ? this.currentPatientID : null)
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  getInsuranceClaimForLedgerID(LedgerID: string) {
    // //console.log('getInsuranceClaimForLedgerID', LedgerID);
    const promise = new Promise((resolve, reject) => {
      this.arService.getInsuranceClaimForLedgerID(LedgerID)
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  getAllInsuranceOrganizations() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllInsuranceOrganizations()
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  getAllInsuranceOrganizationsForCurrentPatient() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getInsuranceOrganizationsForPatientInsurancePayment(this.currentPatientID)
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  getAllARAccounts() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllARAccounts()
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  getAllDoctorARLocations() {
    const promise = new Promise((resolve, reject) => {
      this.arService.getAllDoctorARLocations()
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  showSaveButtonCheck() {
    // //console.log('showSaveButtonCheck');
    //Is payment type selected?
    if (!this.selectedPaymentMethod) {
      // //console.log('showSaveButtonCheck no payment method selected');
      this.showSaveButton = false;
      return;
    }
    if (!this.selectedARAccount) {
      // //console.log('showSaveButtonCheck no AR Account selected');
      this.showSaveButton = false;
      return;
    }
    if (this.paymentAmountNotDistributed < 0) {
      // //console.log('showSaveButtonCheck paymentAmountNotDistributed < 0');
      this.showSaveButton = false;
      return;
    }
    // if (!this.paymentAmount || this.paymentAmount <= 0) {
    //   // //console.log('showSaveButtonCheck paymentAmount < 0');
    //   this.showSaveButton = false;
    //   return;
    // }
    // check to see if at least one claim distribution can be saved
    let showSave = false;
    const claimsApplied = this.claims.filter(a => a.ApplyPayment > 0);
    if (claimsApplied.length > 0) {
      showSave = claimsApplied.every(claim => {
        let itemsApplyPaymentTotal = 0;
        let pendingActions = 0;
        claim.dataARClaimListItems.forEach(claimitem => {
          itemsApplyPaymentTotal += claimitem.ApplyPayment;
          if (claimitem.AmountOutstanding < claimitem.ApplyPayment && claimitem.ApplyPayment > 0 
            && claimitem.enumARInsurancePaymentActionID === null)
            pendingActions++;
        });
        // //console.log('showSaveButtonCheck pendingActions:', pendingActions);


        //  //console.log(`showSaveButtonCheck claimsApplied compare amounts:${ConversionUtilities.roundDecimal(claim.ApplyPayment)}, itemsApplyPaymentTotal: ${ConversionUtilities.roundDecimal(itemsApplyPaymentTotal)}`);
        // if claim apply amount = sum of amounts applied to claim items
        // //console.log('showSaveButtonCheck claim.ApplyPayment:', claim.ApplyPayment);
        // //console.log('showSaveButtonCheck itemsApplyPaymentTotal:', itemsApplyPaymentTotal);
        if (ConversionUtilities.roundDecimal(claim.ApplyPayment) === ConversionUtilities.roundDecimal(itemsApplyPaymentTotal) && pendingActions === 0) {
          return true;
        }
        else {
          // //console.log('showSaveButtonCheck claimsApplied ApplyPayment !=  itemsApplyPaymentTotal');
          return false;
        }
      });
    }
    else if (this.paymentAmount === this.paymentAmountNotDistributed) {
      // no claims applied, all will be created as credit
      showSave = true;
    }

    // if no claims can be saved, disable button
    this.showSaveButton = showSave;
    // force change detection
    this.changeDet.detectChanges();
  }

  saveTotalAmount(event) {
    const inputValue = event.target.value;

    this.paymentAmount = ConversionUtilities.roundDecimal(Number(inputValue.replace(/[^0-9.-]+/g, '')));
    this.paymentAmountNotDistributed = this.paymentAmount;
    this.resetApplyPaymentAmounts();
    this.autoApplyRemainingAmount();

    this.showSaveButtonCheck();
  }


  saveCurrencyField(event, fieldName, ClaimID, ClaimItemID) {
    const inputValue = event.target.value;

    switch (fieldName) {
      case 'paymentAmount': {
        this.paymentAmount = ConversionUtilities.roundDecimal(Number(inputValue.replace(/[^0-9.-]+/g, '')));
        this.paymentAmountNotDistributed = this.paymentAmount;
        this.resetApplyPaymentAmounts();
        this.autoApplyRemainingAmount();
        break;
      }
      case 'ApplyPayment': {
        const num = Number(inputValue.replace(/[^0-9.-]+/g, ''));
        const claimModified = this.claims.find(a => a.ARClaimID === ClaimID);

        if (claimModified) {
          // temporarily restore previous payment amount to this.paymentAmountNotDistributed
          this.paymentAmountNotDistributed = ConversionUtilities.roundDecimal(this.paymentAmountNotDistributed) + ConversionUtilities.roundDecimal(claimModified.ApplyPayment);
          // set raw value
          claimModified.ApplyPayment = num;
          claimModified.claimExpanded = true;
          this.claimExpanded = claimModified.ARClaimID;

          // finally, if main apply amount is now less than sum of claim item amounts, clear claim item amounts
          let claimItemsApplyTotal: number = 0;
          claimModified.dataARClaimListItems.forEach(a => {
            if (a.ApplyPayment) {
              claimItemsApplyTotal += a.ApplyPayment;
            }
          });
          if (claimModified.ApplyPayment < ConversionUtilities.roundDecimal(claimItemsApplyTotal) || claimModified.ApplyPayment == 0) {
            claimModified.dataARClaimListItems.forEach(a => {
              if (a.ApplyPayment) {
                a.ApplyPayment = 0;
              }
            });
          }
        }

        // after update above, set available distribution amount
        this.setPaymentAmountDistributionRemaining();
        this.showSaveButtonCheck();
        break;
      }
    }
    this.showSaveButtonCheck();
  }

  saveApplyPaymentClaimItem(event, ClaimID, ClaimItemID) {
    const inputValue = event.target.value;

    const num = Number(inputValue.replace(/[^0-9.-]+/g, ''));
    const claim = this.claims.find(a => a.ARClaimID.toUpperCase() === ClaimID.toUpperCase());
    //console.log('saveApplyPaymentClaimItem claim:', claim);
    //this.claims.forEach(claim => {
      if (claim) {
        // get total of applied amounts of other claim items for claim
        let claimItemsApplyTotal = 0;
        claim.dataARClaimListItems.forEach(claimitemSum => {
          if (claimitemSum.ARClaimItemID !== ClaimItemID) {
            claimItemsApplyTotal += claimitemSum.ApplyPayment;
          }
        });

        const claimitem = claim.dataARClaimListItems.find(a => a.ARClaimItemID.toUpperCase() === ClaimItemID.toUpperCase());
        //claim.dataARClaimListItems.forEach(claimitem => {
          if (claimitem) {
            // set raw value
            claimitem.ApplyPayment = num;
            claimitem.enumARInsurancePaymentActionID = null;
            // force change detection
            this.changeDet.detectChanges();

            if (num > claim.ApplyPayment) {
              claimitem.ApplyPayment = 0;
              this.createMessage('Amount entered is more than applied to claim', 'Error');
            }
            else if (ConversionUtilities.roundDecimal(num + claimItemsApplyTotal) > claim.ApplyPayment) {
              claimitem.ApplyPayment = 0;
              this.createMessage('Amount entered makes the sum of the applied payments to claim items exceed that of the claim', 'Error');
            }
          }
        //});
      }
    //});
    // update button visibility
    this.showSaveButtonCheck();
  }

  GetClaimItemPaymentActions(claimitem: DataARClaimItemListModel) {
    // //console.log('GetClaimItemPaymentActions:', claimitem);
    // //console.log('GetClaimItemPaymentActions amounts:', claimitem.AmountOutstanding, claimitem.ApplyPayment);
    let actions: any[] = [];
    if (claimitem.AmountOutstanding < claimitem.ApplyPayment) {
      // //console.log('GetClaimItemPaymentActions amounts outstanding > apply payment');
      actions = this.paymentActions.filter(a => 
        a.ValidValueItemId.toUpperCase() === InsurancePaymentActionEnum.PatientCredit.toUpperCase()
        || a.ValidValueItemId.toUpperCase() === InsurancePaymentActionEnum.InsuranceCredit.toUpperCase()
        || a.ValidValueItemId.toUpperCase() === InsurancePaymentActionEnum.ApplyPatientPayment.toUpperCase()
      );
    }
    else if (claimitem.AmountOutstanding > claimitem.ApplyPayment) {
      // //console.log('GetClaimItemPaymentActions amounts outstanding < apply payment');
      actions = this.paymentActions.filter(a => 
        a.ValidValueItemId.toUpperCase() === InsurancePaymentActionEnum.None.toUpperCase()
        || a.ValidValueItemId.toUpperCase() === InsurancePaymentActionEnum.PatientPay.toUpperCase()
        || a.ValidValueItemId.toUpperCase() === InsurancePaymentActionEnum.WriteOff.toUpperCase()
      );

    }
    else {
      actions = this.paymentActions.filter(a => 
        a.ValidValueItemId.toUpperCase() === InsurancePaymentActionEnum.None.toUpperCase()
      );
    }
    // //console.log('GetClaimItemPaymentActions actions:', actions);
    return actions;
  }

  setMinReceivedDate() {
    if (this.selectedPaymentMethod && this.selectedPaymentMethod.enumARPayementTypeID === this.enumPaymentTypeE) {
      this.datePostPaymentMin = new Date();
      if (this.datePostPayment < this.datePostPaymentMin) {
        this.datePostPayment = this.datePostPaymentMin;
      }
    }
    else {
      this.datePostPaymentMin = null;
    }
  }


  checkIfTotalIsValid() {
    if (this.paymentAmount) {
      if (this.paymentAmount > 0 && this.selectedInsuranceCompany && this.selectedARAccount) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  async submitPayment() {
    console.log ('ARInsurancePaymentComponent submitPayment');
    this.isPaymentProcessing = true;
    this.changeDet.detectChanges();
    await this.createDataARPaymentRecord().then( async (newPayment: DataARPaymentModel) => {
      await this.updateInsuranceDocumentGroup(this.insuranceDocuments.map(d => d.DocumentID), newPayment.PaymetnID).then(async (result: any) => {
        // //console.log('createInsuranceDocumentGroup result:', result);
      });
      if (newPayment) {
        this.changesMade = true;
        // expand claim rows if individual selected
        if (this.showOnlyCurrentPatient) {
          this.expandAllClaimsRows();
        }
        // dataARPayments record created
        // record new payment
        this.currentARPayment = newPayment;

        if (this.isClaimRefusal) {
          // setup distributions and save
          // create payment ledger item
          await this.createLedgerItemForPayment(newPayment).then(async (success: number) => {
            console.log ('ARInsurancePaymentComponent submitPayment createLedgerItemForPayment success:', success);
            if (success) {
              // distributions logic
              await this.savePaymentDistributionClickedClaimRefusal();
            }
          });
          this.paymentAmountNotDistributed = 0;
        }
        else {
          // create payment ledger item
          await this.createLedgerItemForPayment(newPayment).then(async (success: number) => {
            console.log ('ARInsurancePaymentComponent submitPayment createLedgerItemForPayment success:', success);
            if (success) {
              // distributions logic
              //this.savePaymentDistributionBalanceCheck();
              await this.savePaymentDistributionClicked().then(async () => {              
              if (this.insuranceOverPayDistributionList.length > 0)
                await this.createCreditForUndistributedPayment().then(() => {
                  this.resetPaymentData();
                });
              else
                this.resetPaymentData();
            });
          }
        });
        }
      }
    }, err => {
      this.isPaymentProcessing = false;
      //console.log('Create Ledger Item err:', err);
      this.createMessage('Problem creating payment record', 'Error');
    });
  }

  resetPaymentData() {
    this.paymentAmountNotDistributed = 0;
    this.paymentAmount = 0;
    this.paymentDescription = '';
    this.selectedPaymentMethod = null;
    this.selectedARAccount = null;
    this.LoadClaimsForInsurance();
    this.resetApplyPaymentAmounts();
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  LoadClaimsForInsurance() {
    //console.log('LoadClaimsForInsurance');
    this.isPaymentProcessing = false;
    this.paymentAmount = 0;
    this.showSaveButtonCheck();
    this.isClaimsLoading = true;
    this.ledgerByPatientCache.clear();
    this.distributionsByTransactionItemCache.clear();
    this.claimPaymentDataLoaded.clear();

    let InsuranceID = Constants.emptyGuid;
    let OrganizationID = Constants.emptyGuid;

    if (this.selectedInsuranceCompany?.InsuranceID && this.selectedInsuranceCompany?.InsuranceID !== Constants.emptyGuid)
      InsuranceID = this.selectedInsuranceCompany.InsuranceID;
    else if (this.selectedInsuranceCompany?.OrganizationID && this.selectedInsuranceCompany?.OrganizationID !== Constants.emptyGuid)
      OrganizationID = this.selectedInsuranceCompany.OrganizationID;

    const promises = [
      this.getAllClaimsWithItems(InsuranceID, OrganizationID)
    ];

    Promise.all(promises).then((results: any[]) => {
      //console.log('getAllClaimsWithItems results', results);
      this.claims = results[0];
      this.claimsRows = this.claims;
      // dont show claims with 0 balance
      // this.claimsRows = this.claimsRows.filter(a => a.ClaimAmountOutstanding > 0);
      if (this.claimsRows.length === 0) {
        this.searchWasEmpty = true;
      }
      else {
        this.searchWasEmpty = false;
      }
      this.claimTotalNumber = this.claimsRows.length;
      this.isClaimsLoading = false;
      //console.log('LoadClaimsForInsurance isLoading false');
      this.isLoading = false;
      this.changeDet.detectChanges();

    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.isClaimsLoading = false;
      this.isLoading = false;
      this.changeDet.detectChanges();

    });
  }

  // Handle selection and deselection of rows model data
  onRowSelected(event: TdoTableSelectionEvent) {
    const claimsModel = this.claims.find(p => p === event.model);
    if (claimsModel) {
      claimsModel.DATA_SELECTED = event.isSelected;
    }
  }

  convertUTCDateToLocalDateFromString(dateString) {
    if (!dateString) {
      return null;
    }
    const date = new Date(dateString);
    return this.convertUTCDateToLocalDate(date);
  }

  convertUTCDateToLocalDate(date) {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }

  async savePaymentDistributionBalanceCheck() {
    // if there is any amount undistributed, show dialog asking if user wants to credit that amount, or continue distributing
    console.log('savePaymentDistributionBalanceCheck');
    this.insuranceOverPayDistributionList = [];
    this.insuranceClaimItemOverPayDistributionList = [];

    // check for over-distributed claim items
    this.claimsRows.forEach(claim => {
      claim.dataARClaimListItems.forEach(claimItem => {
        if ((claimItem.ApplyPayment > 0 && claimItem.ApplyPayment > claimItem.AmountOutstanding)) {
          // add to list of over-payments to credit
          const itemOverpay = new InsurancePaymentOverpayListModel();
          itemOverpay.PatientID = claim.PatientID;
          itemOverpay.ClaimItemID = claimItem.ARClaimItemID;
          itemOverpay.ClaimNumber = claim.TDOClaimNumber;
          itemOverpay.Amount = claimItem.ApplyPayment - (Math.max(claimItem.AmountOutstanding, 0));
          itemOverpay.LOCID = claim.LOCID;
          itemOverpay.enumARInsurancePaymentActionID = claimItem.enumARInsurancePaymentActionID;
          itemOverpay.LedgerID = claimItem.LedgerID;
          itemOverpay.ARTransactionItemID = claim.ARTransactionItemID;
          this.insuranceClaimItemOverPayDistributionList.push(itemOverpay);
        }
      });
    });

    if (this.paymentAmountNotDistributed > 0) {

      // handle overpay distribution list
      let patientClaims: DataARClaimListModel[] = this.claimsRows;
      if (this.showOnlyCurrentPatient) { patientClaims = patientClaims.filter(a => a.PatientID === this.currentPatientID); }
      patientClaims.forEach(c => {
        const dist = new InsurancePaymentOverpayListModel();
        dist.PatientID = c.PatientID;
        dist.PatientName = c.PatientFirstName + ' ' + c.PatientLastName;
        dist.Amount = 0;
        dist.ClaimNumber = c.TDOClaimNumber;
        this.insuranceOverPayDistributionList.push(dist);
      });

      // setup dialog
      const config = new MatDialogConfig();
      config.width = '450px';
      config.height = '500px';
      if (!this.showOnlyCurrentPatient) {
        config.height = '400px';
      }
      config.data = {
        overPayAmount: this.paymentAmountNotDistributed,
        overPayAmountList: this.insuranceOverPayDistributionList
      };
      config.panelClass = 'dialog';

      // open dialog
      const popup = this.dialog.open(ArInsurancePaymentOverpayConfirmComponent, config);
      popup.afterClosed().subscribe(result => {
        // return result
        if (result.length > 0) {
          // move ahead with credit
          //console.log('overpaymentconfirm');
          this.isPaymentProcessing = true;
          this.insuranceOverPayDistributionList = result;
          this.submitPayment();
        }
      });
    }
    else {
      this.submitPayment();
    }
  }

  async createCreditForUndistributedPayment() {
    try {
      //console.log('createCreditForUndistributedPayment isLoading true');
      this.isLoading = true;

      // credit ledger item
      const ledgerItemCredit = new DataARLedgerModel();
      ledgerItemCredit.LOCID = parseInt(localStorage.getItem('LOCID'));
      ledgerItemCredit.PatientId = this.globals.currentPatientId;
      ledgerItemCredit.PostDate = new Date();
      ledgerItemCredit.Amount = this.paymentAmountNotDistributed;
      ledgerItemCredit.Description = 'Undistributed insurance payment credit - Administrative';
      ledgerItemCredit.Reference = 'Overpay Conversion';
      ledgerItemCredit.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.CreditAdjustmentInsurance;
      ledgerItemCredit.enumARLedgerItemOriginTypeID = this.enumLedgerItemOriginTypeInsurance;
      ledgerItemCredit.enumLedgerItemStatusID = this.enumLedgerItemStatusOutstanding;
      ledgerItemCredit.PaymetnID = this.currentARPayment.PaymetnID;

      await this.arService.saveLedgerItem(ledgerItemCredit).toPromise();
      this.createMessage('Credit created for undistributed payment amount', 'Success');
      //console.log('createCreditForUndistributedPayment isLoading false');
      this.isLoading = false;
    } catch (err) {
      console.error('createCreditForUndistributedPayment error', err);
      this.createMessage('Credit not created', 'Error');
      this.isLoading = false;
    }
  }

  async savePaymentDistributionClickedClaimRefusal() {
    //console.log('savePaymentDistributionClickedClaimRefusal isLoading true');
    this.isLoading = true;

    // get claims to save
    const claimsToSave: DataARClaimListModel[] = [];
    this.claims.forEach(claim => {
      claimsToSave.push(claim);
    });

    if (claimsToSave.length) {
      await this.savePaymentDistribution(claimsToSave, this.insuranceOverPayDistributionList, this.insuranceClaimItemOverPayDistributionList).then((result: number) => {
        if (result) {
          if (result === 1) {
            this.createMessage('Claim refusal succeeded', 'Success!');
            this.dialogRef.close(true);
          }
        }
      }, err => {
        this.createMessage('Problem refusing claim', 'Error');
        this.isLoading = false;
        this.isPaymentProcessing = false;
      });
    }
    else {
      this.createMessage('Problem refusing claim - no claims to refuse', 'Error');
      //console.log('savePaymentDistributionClickedClaimRefusal isLoading false');
      this.isLoading = false;
      this.isPaymentProcessing = false;
    }
  }

  async savePaymentDistributionClicked() {
    console.log ('ARInsurancePaymentComponent savePaymentDistributionClicked');
    //console.log('savePaymentDistributionClicked isLoading true');
    this.isLoading = true;
    this.isPaymentProcessing = true;

    // get claims to save
    const claimsToSave: DataARClaimListModel[] = [];
    this.claims.forEach(claim => {

      // only look at claims with an amount applied and claims with a payment action selected
      if (claim.ApplyPayment > 0 
          || (claim.dataARClaimListItems.some( item => item.enumARInsurancePaymentActionID !== null && item.enumARInsurancePaymentActionID !== Constants.emptyGuid))
          || claim.MarkedForClose
        ) {
          console.log ('ARInsurancePaymentComponent savePaymentDistributionClicked claim:', claim);
        // get total of applied amounts of other claim items for claim
        let claimItemsApplyTotal = 0;
        claim.dataARClaimListItems.forEach(claimitemSum => {
          claimItemsApplyTotal += claimitemSum.ApplyPayment;
          if (claim.MarkedForClose && claimitemSum.enumARInsurancePaymentActionID === null
            &&  claimitemSum.ApplyPayment < claimitemSum.AmountOutstanding) {
            claimitemSum.enumARInsurancePaymentActionID = InsurancePaymentActionEnum.PatientPay.toUpperCase();
          }
        });

        // if total claim item apply amounts = total claim apply amount, then we can save the claim
        if (ConversionUtilities.roundDecimal(claimItemsApplyTotal) === claim.ApplyPayment) {
          claimsToSave.push(claim);
        }
      }
    });

    if (claimsToSave.length) {

      // prevent apply amounts from exceeding amount owed/outstanding
      // any overpayments will be handled on the server in the call below
      claimsToSave.forEach(a => {
        a.dataARClaimListItems.forEach(b => {
          if (b.ApplyPayment > b.AmountOutstanding) {
            b.ApplyPayment = b.AmountOutstanding;
          }
        });
      });

      this.insuranceClaimItemOverPayDistributionList.forEach(a => {
        a.PaymentID = this.currentARPayment.PaymetnID;
      });
      //console.log('savePaymentDistributionClicked savepaymentdistribution call');
      await this.savePaymentDistribution(claimsToSave, this.insuranceOverPayDistributionList, this.insuranceClaimItemOverPayDistributionList).then((result: number) => {
        if (result) {
          //console.log('savePaymentDistributionClicked savePaymentDistribution result:', result);
          if (result === 1) {
            this.createMessage('Insurance payment distribution succeeded', 'Success!');
            this.changesMade = true;
            // reset expansion status
            this.claimExpanded = '';

            // if all distributed...
            if (this.paymentAmountNotDistributed <= 0) {
              // reset payment screen
              this.currentARPayment = null;
              this.paymentAmountNotDistributed = 0;
              this.paymentAmount = 0;
            }
          }
          //console.log('savePaymentDistributionClicked savePaymentDistributionClicked ended isloading false');
          this.isLoading = false;
          //this.isPaymentProcessing = false;
        }
      }, err => {
        console.error('savePaymentDistributionClicked error', err);
        this.createMessage('Problem distributing insurance payment', 'Error');
        this.isLoading = false;
        this.isPaymentProcessing = false;
      });
      //console.log('savePaymentDistributionClicked savePaymentDistributionClicked ended');
    }
    else {
      //console.log('savePaymentDistributionClicked no claims to save isloading false');
      this.isLoading = false;
      this.isPaymentProcessing = false;
    }
    //console.log('savePaymentDistributionClicked ended.');
    // retest button visibility
    this.showSaveButtonCheck();
  }

  savePaymentDistribution(claims: DataARClaimListModel[], insuranceOverPayList: InsurancePaymentOverpayListModel[], insuranceClaimItemOverPayList: InsurancePaymentOverpayListModel[]) {
    // //console.log('savePaymentDistribution claims:', claims);
    const promise = new Promise((resolve, reject) => {
      this.arService.saveInsurancePaymentDistributions(claims, this.currentARPayment.PaymetnID, insuranceOverPayList, insuranceClaimItemOverPayList, this.showOnlyCurrentPatient ? this.currentPatientID : null, this.isClaimRefusal)
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  openDrawInNewWindow(documentTag: string): void {
    //console.log('openDrawInNewWindow documentTag:', documentTag);
    this.selectedDocumentTag = documentTag;
    const tags: string[] = [];
    tags.push(documentTag);
    localStorage.setItem('tags-imaging', JSON.stringify(tags));
    this.uiService.openAcquireDefaultDevice(tags, false, false);
    //this.uiService.openImagingWindow();
    //this.uiService.openAcquire(tags, false);
  }

  openUpload(documentTag: string, fileEnumDescription: string) {
    //console.log('openUpload documentTag:', documentTag);
    this.selectedDocumentTag = documentTag;
    this.selectedDocumentDescription = fileEnumDescription;
    document.getElementById('fileInput').click();
  }

  fileSelected(files: FileList) {
    //console.log('fileSelected', files);
    //this.isImagesLoading = true;
    const models: DocumentUploadModel[] = [];
    const fz = Array.from(files);

    for (const file of fz) {
      //const fileModel = file;
      const uploadModel = new DocumentUploadModel();
      uploadModel.blob = file;
      uploadModel.docClassId = DocumentClassEnum.Original;
      uploadModel.docTypeId = DocumentTypeEnum.Insurance;
      uploadModel.hasAnnotation = false;
      uploadModel.docTagIds = [this.selectedDocumentTag];
      uploadModel.patientId = this.globals.currentPatientId;
      uploadModel.patientCaseId = this.globals.currentPatientCaseId;
      uploadModel.createDate = this.datePipe.transform(new Date(file.lastModified), 'MMM dd, yyyy H:mm:ss');
      uploadModel.description = this.selectedDocumentDescription;

      models.push(uploadModel);
      if (models.length === files.length) {
        this.fileService.uploadDocuments(models).subscribe((response) => {
          response.documents.forEach(upDoc => {
              // //console.log('fileSelected upDoc', upDoc);
            this.insuranceDocuments.push(upDoc);
            this.createInsuranceDocumentGroup(upDoc.DocumentID, this.globals.currentPatientId).then((result: any) => {
              // //console.log('createInsuranceDocumentGroup result:', result);
            });
          });
          this.changeDet.detectChanges();
        }, error => { console.error('fileSelected error', error); });
      }
    }
  }

  createInsuranceDocumentGroup(documentID: string, objectID: string) {
    let promise = new Promise((resolve, reject) => {
      const cmodel = new DocumentGroupCreationModel();
      cmodel.documentIds = [documentID];
      cmodel.ObjectId = objectID;
      cmodel.PatientId = this.globals.currentPatientId;
      cmodel.ParentObjectName = 'dataInsurancePayment';
      this.fileService.createDocumentGroup(cmodel).subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  updateInsuranceDocumentGroup(documentIDs: string[], objectID: string) {
    let promise = new Promise((resolve, reject) => {
      const cmodel = new DocumentGroupCreationModel();
      cmodel.documentIds = documentIDs;
      cmodel.ObjectId = objectID;
      cmodel.PatientId = this.globals.currentPatientId;
      cmodel.ParentObjectName = 'dataInsurancePayment';
      this.fileService.updateDocumentGroup(cmodel).subscribe({ next: resolve, error: reject });
    });
    return promise;
  }


  showOnlyCurrentPatientChanged($event: MatCheckboxChange) {
    this.claimsRows = [];
    this.claims = [];
    this.claimTotalNumber = 0;

    if ($event.checked) {
      // patient only checked
      this.isLoading = true;
      this.getAllInsuranceOrganizationsForCurrentPatient().then((results: any) => {
        this.insuranceCompanyList = results;
        this.selectedInsuranceCompany = null;
        this.searchWasEmpty = null;
        this.isLoading = false;

        // set selectedInsuranceCompany and load claims for default patient insurance
        this.setAndLoadClaimsForDefaultPatientInsurance();
      }, err => {
        this.createMessage('Something went wrong', 'Error');
        this.isLoading = false;
        this.changeDet.detectChanges();
      });
    }
    else {
      // all patients
      this.isLoading = true;
      this.getAllInsuranceOrganizations().then((results: any) => {
        this.insuranceCompanyList = results;
        this.selectedInsuranceCompany = null;
        this.searchWasEmpty = null;
        this.isLoading = false;
        this.changeDet.detectChanges();
      }, err => {
        this.createMessage('Something went wrong', 'Error');
        this.isLoading = false;
        this.changeDet.detectChanges();
      });
    }
  }

  setAndLoadClaimsForDefaultPatientInsurance() {
    // //console.log('ArInsurancePaymentComponent setAndLoadClaimsForDefaultPatientInsurance');
    // load claims for default insurance
    this.selectedInsuranceCompany = this.insuranceCompanyList.find(a => a.IsActive && a.InsuranceOrder === 0);

    // //console.log('ArInsurancePaymentComponent setAndLoadClaimsForDefaultPatientInsurance selectedInsuranceCompany:', this.selectedInsuranceCompany);
    if (this.selectedInsuranceCompany) {
      this.LoadClaimsForInsurance();
    } else {
      this.isLoading = false;
      this.changeDet.detectChanges();
    }
  }

  createLedgerItemForPayment(payment: DataARPaymentModel) {
    const promise = new Promise((resolve, reject) => {

      const payload = new CreateLedgerItemForPaymentModel();
      payload.PaymentID = payment.PaymetnID;
      payload.enumARLedgerItemOriginTypeID = this.enumLedgerItemOriginTypeInsurance;
      payload.enumARLedgerItemTypeID = LEDGER_ITEM_TYPE.CreditPayment;

      this.arService.createLedgerItemForPayment(payload)
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

  resetApplyPaymentAmounts() {
    // //console.log('resetApplyPaymentAmounts');
    this.claimsRows.forEach(claim => {
      claim.ApplyPayment = 0;
      claim.dataARClaimListItems.forEach(item => {
        item.ApplyPayment = 0;
      });
    });
  }

  autoApplyRemainingAmount() {
    // //console.log('autoApplyRemainingAmount: ', this.paymentAmountNotDistributed);
    let amountRemaining = this.paymentAmountNotDistributed;
    this.claimsRows.forEach(claim => {
      const claimAmountDue = this.returnAmountDue(claim);
      // //console.log(`autoApplyRemainingAmount claim:${claim.ARClaimID} claimAmountDue: ${claimAmountDue} amountRemaining: ${amountRemaining}`);

      if (amountRemaining <= 0 || claimAmountDue <= 0)
        return;
      let amountDue = claimAmountDue;
      if (amountDue <= 0)
        return;

      // //console.log(`autoApplyRemainingAmount amountDue> 0 claim:${claim.ARClaimID} amountDue: ${amountDue} amountRemaining: ${amountRemaining}`);
      // try to apply payment
      if (amountDue <= amountRemaining) {
        claim.ApplyPayment = ConversionUtilities.roundDecimal(amountDue);
        amountRemaining = ConversionUtilities.roundDecimal(amountRemaining - amountDue);
      }
      else {
        claim.ApplyPayment = ConversionUtilities.roundDecimal(amountRemaining);
        amountRemaining = 0;
        this.paymentAmountNotDistributed = amountRemaining;
      }

      // auto dist to claim items
      if (claim.ApplyPayment) {
        claim.claimExpanded = true;
        let itemsAmountRemaining = ConversionUtilities.roundDecimal(claim.ApplyPayment);
        claim.dataARClaimListItems.forEach(item => {
          // try to apply item payment
          // //console.log(`autoApplyRemainingAmount claimitem:${item.ARClaimItemID} AmountOutstanding: ${item.AmountOutstanding} itemsAmountRemaining: ${itemsAmountRemaining}`);

          if (item.AmountOutstanding <= itemsAmountRemaining && itemsAmountRemaining > 0) {
            item.ApplyPayment = item.AmountOutstanding;
            itemsAmountRemaining = ConversionUtilities.roundDecimal(itemsAmountRemaining - item.ApplyPayment);
          }
          else {
            item.ApplyPayment = itemsAmountRemaining;
            itemsAmountRemaining = 0;
          }
        });
      }
      // update remaining
      this.paymentAmountNotDistributed = ConversionUtilities.roundDecimal(amountRemaining);

      return true;
    });

    this.showSaveButtonCheck();
  }

  returnAmountDue(claim) {

    let AmountDue = 0;
    if (claim.InsEstimateAmountDue) {
      AmountDue = ConversionUtilities.roundDecimal(claim.InsEstimateAmountDue);
    }

    return AmountDue;
  }

  clearDistributions() {
    // reset payment distributions
    this.resetApplyPaymentAmounts();
    this.setPaymentAmountDistributionRemaining();
    this.contractAllClaimsRows();
  }



  openInsuranceFile(report: any) {
    //console.log("Opening report:", report);

    let documentIds: string[] = [];
    documentIds.push(report.ParentDocumentID);

    const config = new MatDialogConfig();
    config.panelClass = 'standard-dialog';
    config.data = documentIds;
    config.maxWidth = '100dvw';
    config.maxHeight = '100dvh';
    config.width = '98%';
    config.height = '98%';
    //console.log('ArInsurancePaymentComponent openInsuranceFile:', config);
    this.dialog.open(TdoOrganizerSlideshowDialogComponent, config).afterClosed().subscribe((res) => {
    });

  }

  deleteInsuranceDocument(document: any, event: MouseEvent) {
    // Stop event propagation to prevent opening the document when clicking delete
    event.stopPropagation();
    
    this.dialogService.openConfirmDialog(
      `Are you sure you want to delete this document: ${document.Description}?`
    ).subscribe(async (confirmed) => {
      if (confirmed) {
        try {
          // Delete the document using the ParentDocumentID (the original document ID)
          await this.fileService.markDocumentAsDeleted(document.ParentDocumentID).toPromise();
          
          // Remove from the insuranceDocuments array
          const index = this.insuranceDocuments.findIndex(d => d.DocumentID === document.DocumentID);
          if (index > -1) {
            this.insuranceDocuments.splice(index, 1);
          }
          this.changeDet.detectChanges();
          this.uiService.displayMessage('Success', 'Document deleted successfully');
        } catch (err) {
          console.error('Error deleting insurance document:', err);
          this.uiService.displayMessage('Error', 'Error deleting document');
        }
      }
    });
  }


  setPaymentMethod() {
    if (this.isValPay()) {
      this.datePostPaymentMin = new Date();
      if (this.dateReceivedPayment < this.datePostPaymentMin) {
        this.dateReceivedPayment = this.datePostPaymentMin;
      }
      this.isDisabledReceivedDate = true;
    }
    else {
      this.isDisabledReceivedDate = false;
      this.datePostPaymentMin = null;
    }
    this.paymentAmountNotDistributed = this.paymentAmount;
    // try to set ARAccountID
    this.selectedARAccount = null;
    if (this.selectedPaymentMethod.ARAccountID) {
      this.selectedARAccount = this.arAccounts.find(a => a.ARAccountID === this.selectedPaymentMethod.ARAccountID);
    }
    this.contractAllClaimsRows();
    this.autoApplyRemainingAmount();
    this.setMinReceivedDate();
  }

  isValPay() {
    let valPayCheck = false;
    if (this.selectedPaymentMethod?.enumARPayementTypeID === this.enumPaymentTypeE) {
      valPayCheck = true;
    }
    return valPayCheck;
  }

  openPaymentProcessorTotalConfirmation() {
    const pendingToDisperse = this.claimsRows.filter(a => this.returnApplyAmountReamining(a) > 0);
    if (pendingToDisperse.length > 0) {
      this.createMessage(`Please distribute the correct claim payment to procedures before continuing. \nClaims : ${pendingToDisperse.map(c => c.TDOClaimNumber).join(', ')}.`, 'Error');
      return;
    }
    const disperseAmountExceeded = this.claimsRows.filter(a => this.returnApplyAmountReamining(a) < 0);
    if (disperseAmountExceeded.length > 0) {
      this.createMessage(`Please verify that all claim distributions don't exceed claim amount. \nClaims : ${disperseAmountExceeded.map(c => c.TDOClaimNumber).join(', ')}.`, 'Error');
      return;
    }
    // get totals for doctor payments
    this.dataDoctorARPaymentProcessors = [];
    this.claimsRows.forEach(claim => {
      if (claim.ApplyPayment) {
        const docProcessor = this.dataDoctorARPaymentProcessors.find(c => c.DoctorARLocId === claim.DoctorARLocId);
        if (docProcessor) {
          docProcessor.PaymentAmountTotal = docProcessor.PaymentAmountTotal + claim.ApplyPayment;
          docProcessor.DoctorARLocId = claim.DoctorARLocId;
        }
        else {
          const docPP = new DataDoctorArPaymentProcessorModel();
          docPP.PaymentAmountTotal = claim.ApplyPayment;
          docPP.DoctorARLocId = claim.DoctorARLocId;

          this.dataDoctorARPaymentProcessors.push(docPP);
        }
      }
    });

    // processor names
    this.dataDoctorARPaymentProcessors.forEach(name => {
      // get account name
      const doc = this.dataDoctorARPaymentProcessorsAll.find(c => c.DoctorARLocId === name.DoctorARLocId);
      if (doc) {
        name.PaymentProcessorName = doc.PaymentProcessorName;
        name.PaymentProcessorId = doc.PaymentProcessorId;
      }
      // get account name
      const acct = this.arAccounts.find(c => c.DoctorARLocId === name.DoctorARLocId);
      if (acct) {
        name.ARAccountName = acct.AccountName;
      }
    });

    // open dialog
    if (this.dataDoctorARPaymentProcessors.length > 0) {
      if (this.paymentAmountNotDistributed > 0) {
        this.dataDoctorARPaymentProcessors[0].PaymentAmountTotal += this.paymentAmountNotDistributed;
      }
      const promise = new Promise((resolve, reject) => {
        const dialogRef = this.dialog.open(ArInsurancePaymentProcessorTotalConfirmComponent, {
          panelClass: 'dialog',
          width: '700px',
          height: '390px',
          disableClose: true,
          data: {
            totals: this.dataDoctorARPaymentProcessors,
            paymentMethod: this.selectedPaymentMethod,
            arAccounts: this.arAccounts,
            claims: this.claimsRows,
            patientId: this.showOnlyCurrentPatient ? this.currentPatientID : null,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.changesMade = true;
            // reset claims
            this.LoadClaimsForInsurance();
            // reset expansion status
            this.claimExpanded = '';
          }
        });
      });
      return promise;
    }
    else {
      this.createMessage('No claims have been selected', 'Error');
    }
  }

  claimItemActionSelected(claim: DataARClaimListModel, claimitem: DataARClaimItemListModel) {
    this.setMinReceivedDate();
    this.showSaveButtonCheck();
  }

  clearSearchBox() {
    const keyEvent = new KeyboardEvent('keydown');
    Object.defineProperty(keyEvent, 'keyCode', {
      get: () => ''
    });
    Object.defineProperty(keyEvent, 'target', {
      get: () => ''
    });

    this.searchInput = '';

    this.searchChanged(keyEvent);
  }

  expandAllClaimsRows() {
    this.claimsRows.forEach(a => {
      a.claimExpanded = true;
      this.loadPatientPaymentsForClaimItems(a);
    });
  }

  expandClaim(claim: DataARClaimListModel): void {
    claim.claimExpanded = true;
    this.loadPatientPaymentsForClaimItems(claim);
  }

  private claimPaymentDataLoaded = new Set<string>();
  private ledgerByPatientCache = new Map<string, Observable<DataARLedgerListModel[]>>();
  private distributionsByTransactionItemCache = new Map<string, Observable<any[]>>();

  private getLedgerForPatientCached(patientId: string): Observable<DataARLedgerListModel[]> {
    if (!this.ledgerByPatientCache.has(patientId)) {
      this.ledgerByPatientCache.set(patientId, this.arService.getLedgerForPatient2(patientId).pipe(
        share({ connector: () => new ReplaySubject(1), resetOnError: true })));
    }
    return this.ledgerByPatientCache.get(patientId)!;
  }

  private getPaymentDistributionsCached(transactionItemId: string): Observable<any[]> {
    if (!this.distributionsByTransactionItemCache.has(transactionItemId)) {
      this.distributionsByTransactionItemCache.set(transactionItemId, this.arService.getPaymentDistributionsForLedgerTransaction(transactionItemId).pipe(
        share({ connector: () => new ReplaySubject(1), resetOnError: true })));
    }
    return this.distributionsByTransactionItemCache.get(transactionItemId)!;
  }

  loadPatientPaymentsForClaimItems(claim: DataARClaimListModel): void {
    if (this.claimPaymentDataLoaded.has(claim.ARClaimID)) {
      return;
    }
    const itemsNeedingData = claim.dataARClaimListItems?.filter(item => item.PatientPaymentsTotal == null && item.ARTransactionItemID) || [];
    if (!itemsNeedingData.length) {
      return;
    }
    this.claimPaymentDataLoaded.add(claim.ARClaimID);
    itemsNeedingData.forEach(item => {
      item.isPaymentDataLoading = true;
      item.hasPaymentDataError = false;
    });
    this.changeDet.detectChanges();

    const ledgerItems$ = (claim.PatientID ? this.getLedgerForPatientCached(claim.PatientID) : of([] as DataARLedgerListModel[])).pipe(
      map(data => ({ data, failed: false })),
      catchError(() => of({ data: [] as DataARLedgerListModel[], failed: true }))
    );
    const distributions$ = itemsNeedingData.map(item => this.getPaymentDistributionsCached(item.ARTransactionItemID).pipe(
      map(data => ({ data, failed: false })),
      catchError(() => of({ data: [] as any[], failed: true }))
    ));

    forkJoin([ledgerItems$, forkJoin(distributions$)]).subscribe({
      next: ([ledgerResult, distributionResults]) => {
        const ledgerItems = ledgerResult.data;
        const ledgerFailed = ledgerResult.failed;
        const isVoided = (a: { PaymentDistributionStatus?: string }) => a.PaymentDistributionStatus === this.enumARDistribItemStatusVoid;
        const isActualInsurancePayment = (a: { PaymentDistributionTypeName?: string }) => a.PaymentDistributionTypeName?.toUpperCase() === 'STANDARD';
        const isInsuranceOverpayReassignment = (a: { PaymentDistributionTypeName?: string }) => a.PaymentDistributionTypeName?.toUpperCase() === 'INS. OVERPAY';

        // Per item: if either the shared ledger fetch or this item's own distribution fetch failed, mark it
        // as errored and leave its fields untouched (still null) so a retry can pick it back up, without
        // affecting sibling items that succeeded.
        itemsNeedingData.forEach((item, index) => {
          const distributionResult = distributionResults[index];
          if (ledgerFailed || distributionResult.failed) {
            item.hasPaymentDataError = true;
            item.isPaymentDataLoading = false;
            return;
          }

          // Patient Payment / Insurance Payment: sum source-filtered payment distributions for this item's own
          // transaction (this is the approach that was already confirmed correct before the ledger migration).
          // Computed first because it also doubles as the most reliable "has this item had real activity"
          // signal for the Estimate fields below - a fully-processed item's Debit row(s) end up marked Void
          // as part of normal backend lifecycle (not because anything was actually voided), so the Debit row's
          // own void status/aggregate fields can't be trusted alone.
          const distributions = distributionResult.data || [];
          // A source credit row with no PaymetnID and no linked dataARPaymentDistribs was never backed by a
          // real payment (e.g. a directly-issued courtesy/administrative credit) - not real cash, so applying
          // it shouldn't count toward Patient/Insurance Payment. A source credit row that does carry a
          // PaymetnID (e.g. an undistributed cash payment later converted to a reusable credit) is real money
          // and should still count when applied. ArPaymentCancelComponent.createCredit() produces a third
          // shape: a real-payment-backed credit row whose own PaymetnID is left unset, linked back to the
          // original payment only through a dataARPaymentDistribs entry - that also counts as monetary.
          // enumARLedgerItemTypeID alone can't make this distinction - all cases end up as a Void
          // CreditAdjustment wrapper row.
          const isNonMonetaryAdjustment = (row?: DataARLedgerListModel): boolean =>
            !row?.PaymetnID && !(row?.dataARPaymentDistribs || []).some(d => d.PaymetnID);
          const isPatientOriginCredit = (a: { enumPaymentSourceID?: string; PaymentSourceObjectID?: string }): boolean => {
            if (a.enumPaymentSourceID !== PAYMENT_SOURCE.ApplyCredit) {
              return true;
            }
            const sourceCreditRow = (ledgerItems || []).find(l => l.LedgerID === a.PaymentSourceObjectID);
            return sourceCreditRow?.enumARLedgerItemOriginTypeID === this.enumLedgerItemOriginTypePatient
              && !isNonMonetaryAdjustment(sourceCreditRow);
          };
          const isInsuranceOriginCredit = (a: { enumPaymentSourceID?: string; PaymentSourceObjectID?: string }): boolean => {
            if (a.enumPaymentSourceID !== PAYMENT_SOURCE.ApplyCredit) {
              return false;
            }
            const sourceCreditRow = (ledgerItems || []).find(l => l.LedgerID === a.PaymentSourceObjectID);
            return sourceCreditRow?.enumARLedgerItemOriginTypeID === this.enumLedgerItemOriginTypeInsurance
              && !isNonMonetaryAdjustment(sourceCreditRow);
          };
          const patientPaymentDistributions = distributions.filter(a =>
            !isVoided(a) && !isInsuranceOverpayReassignment(a)
            && (a.enumPaymentSourceID === PAYMENT_SOURCE.Patient
                || (a.enumPaymentSourceID === PAYMENT_SOURCE.ApplyCredit && isPatientOriginCredit(a))));
          const insuranceDistributions = distributions.filter(a =>
            !isVoided(a) && (isInsuranceOverpayReassignment(a)
              || (a.enumPaymentSourceID === PAYMENT_SOURCE.Insurance && isActualInsurancePayment(a))
              || isInsuranceOriginCredit(a)));
          // Any non-voided distribution (payment, applied credit, or write-off) means the debit row's live
          // balance is trustworthy, regardless of whether that distribution counted toward the payment totals above.
          const hasDistributionActivity = distributions.some(a => !isVoided(a));
          item.PatientPaymentsTotal = patientPaymentDistributions.reduce((sum, a) => sum + (a.PaymentAmount || 0), 0);
          item.PaymentsTotal = insuranceDistributions.reduce((sum, a) => sum + (a.PaymentAmount || 0), 0);

          // Patient/Insurance Estimate: from the ledger's Debit (charge) row, which reflects payment leftovers
          // reassigned between patient and insurance (the item's own PatientResponsibility/InsuranceAmount are
          // not recomputed by the backend for that). When a claim is voided and recreated, the same
          // ARTransactionItemID can carry a Debit row for each claim - prefer the one for the claim currently
          // shown, regardless of its void status (void here can just mean "superseded" once the claim is
          // fully processed, not an actual void action). A freshly (re)created claim's item has no posted
          // activity at all yet - fall back to the item's own raw fields in that case. An item with real
          // posted activity (from distributions above, or the Debit row's own adjustment/payment totals) is
          // trusted as fully resolved even when its due amounts are legitimately 0 (fully settled/overpaid).
          const debitRow = (ledgerItems || []).find(l =>
            l.ARTransactionItemID === item.ARTransactionItemID
            && l.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit
            && l.ARClaimID === claim.ARClaimID)
            || (ledgerItems || []).find(l =>
              l.ARTransactionItemID === item.ARTransactionItemID
              && l.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit
              && !l.ARClaimID);
          const hasActivity = hasDistributionActivity || (debitRow && (
            debitRow.PaymentsTotal || debitRow.PaymentsTotalPatient || debitRow.PaymentsTotalInsurance
            || debitRow.TotalCreditAdjustments || debitRow.TotalDebitAdjustments));
          item.PatientEstimateAmount = (debitRow && hasActivity) ? debitRow.AmountDuePatient : item.PatientResponsibility;
          item.InsuranceAmount = (debitRow && hasActivity) ? debitRow.AmountDueInsurance : item.InsuranceAmount;

          item.isPaymentDataLoading = false;
        });

        // Insurance overpayment credit: when a claim item is overpaid by insurance, the leftover is recorded as
        // a payment-level "Overpaid claim item credit" ledger row that may have no ARTransactionItemID link, so
        // it can't always be matched to an item via distributions. Only attribute it to an item when the backend
        // gives a reliable link - a direct ARTransactionItemID match, or (when the claim has exactly one item) a
        // claim-level ARClaimID match. Anything else (administrative/undistributed credits, credits spanning
        // multiple claims/items) stays out of the item totals rather than being guessed at. Only items that
        // loaded successfully are eligible.
        const successfulItems = itemsNeedingData.filter(item => !item.hasPaymentDataError);
        const overpayCredits = (ledgerItems || []).filter(l =>
          l.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditAdjustmentInsurance
          && l.enumARLedgerItemOriginTypeID === this.enumLedgerItemOriginTypeInsurance
          && l.PaymetnID === this.currentARPayment?.PaymetnID
          && l.enumLedgerItemStatusID !== LEDGER_ITEM_STATUS.Void);

        overpayCredits.forEach(credit => {
          const linkedItem = successfulItems.find(item => item.ARTransactionItemID === credit.ARTransactionItemID);
          if (linkedItem) {
            linkedItem.PaymentsTotal += credit.Amount || 0;
            return;
          }
          const claimLinked = credit.ARClaimID && credit.ARClaimID === claim.ARClaimID;
          if (claimLinked && successfulItems.length === 1) {
            successfulItems[0].PaymentsTotal += credit.Amount || 0;
          }
          // otherwise: no reliable item/claim association - leave the credit out of item-level totals.
        });

        if (itemsNeedingData.some(item => item.hasPaymentDataError)) {
          this.claimPaymentDataLoaded.delete(claim.ARClaimID);
        }
        this.changeDet.detectChanges();
      },
      error: () => {
        // Defensive fallback: each source above already recovers via catchError, so this should not normally
        // fire, but guard against it leaving spinners stuck forever.
        itemsNeedingData.forEach(item => {
          item.isPaymentDataLoading = false;
          item.hasPaymentDataError = true;
        });
        this.claimPaymentDataLoaded.delete(claim.ARClaimID);
        this.changeDet.detectChanges();
      }
    });
  }

  contractAllClaimsRows() {
    this.claimsRows.forEach(a => {
      a.claimExpanded = false;
    });
  }

  returnApplyAmountReamining(claim: DataARClaimListModel) {
    let claimItemsApplyTotal: number = 0;
    claim.dataARClaimListItems.forEach(a => {
      if (a.ApplyPayment) {
        claimItemsApplyTotal += a.ApplyPayment;
      }
    });
    return ConversionUtilities.roundDecimal(claim.ApplyPayment - claimItemsApplyTotal);
  }

  cancelClicked() {
    this.close(this.changesMade);
  }

  includeClosedClaimsChanged($event: MatCheckboxChange) {
    this.claimsRows = [];
    this.claimTotalNumber = 0;
    //console.log('includeClosedClaimsChanged this.selectedInsuranceCompany: ', this.selectedInsuranceCompany);
    //console.log('includeClosedClaimsChanged this.includeClosed: ', this.includeClosed);

    if (this.selectedInsuranceCompany) {
      this.LoadClaimsForInsurance();
    }
  }

  async processPayment() {
    if (this.isProcessPaymentInProgress) {
      return;
    }
    this.isProcessPaymentInProgress = true;
    try {
      if (!this.paymentAmount || this.paymentAmount <= 0) {
        const closeClaims = this.claimsRows.some(a => a.MarkedForClose);
        let message = 'Payment amount is zero. Do you want to continue?';
        if (closeClaims) {
          message = 'Payment amount is zero. Do you want to continue? <br/><b style="color: red;">Any remaining insurance estimate amount will be transferred to the patient\'s responsibility.</b>';
        }
        const zeroPayment = await this.dialogService.openConfirmDialog(message, true, false, 'Payment Amount is Zero...').toPromise();
          if (zeroPayment === false) {
            this.isProcessPaymentInProgress = false;
            this.changeDet.detectChanges();
            return;
          }
      }
      this.changeDet.detectChanges();
      if (this.isValPay())
        this.openPaymentProcessorTotalConfirmation();
      else {
        //console.log('Process non valpay payment');
        this.showSaveButtonCheck();
        if (this.showSaveButton)
          this.savePaymentDistributionBalanceCheck();
      }
    } finally {
      this.isProcessPaymentInProgress = false;
    }
  }

  loadClaimRefusal() {
    this.isClaimRefusal = true;
    //console.log('isClaimRefusal:', this.isClaimRefusal);

    const promises2 = [
      this.getInsuranceClaimForLedgerID(this.data.LedgerItem.ARTransactionItemID)
    ];

    Promise.all(promises2).then((results2: any) => {
      if (results2) {
        this.insuranceCompanyList.forEach(a => {
          if (a.InsuranceID === results2[0].InsuranceID) {
            this.selectedInsuranceCompany = a;
          }
        });

        const insType = this.getInsuranceTypeLabel(this.selectedInsuranceCompany?.InsuranceOrder);
        this.insuranceName = insType ? `${results2[0].InsuranceName} (${insType})` : results2[0].InsuranceName;
        this.selectedARAccount = this.arAccounts.find(a => a.ARAccountID === results2[0].ARAccountID);
        this.claims = results2[0].TheClaim;
        this.claimsRows = this.claims;
        this.claimExpanded = results2[0].ARClaimID;
        this.selectedPaymentMethod = new CfgARPaymentMethodModel();
        this.selectedPaymentMethod.enumARPayementCCTypeID = null;
        this.selectedPaymentMethod.enumARPayementETypeID = null;
        this.selectedPaymentMethod.enumARPayementTypeID = EnumARPaymentType.Check;

        this.claimsRows.forEach(a => {
          a.DoctorARLocId = this.selectedARAccount.DoctorARLocId;
          a.MarkedForClose = true;
          a.ApplyPayment = 0;
          a.dataARClaimListItems.forEach(b => {
            b.enumARInsurancePaymentActionID = InsurancePaymentActionEnum.PatientPay;
            b.ApplyPayment = 0;
          });
        });
        this.isClaimsLoading = false;
      }
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.isClaimsLoading = false;
    });

    this.paymentAmount = 0;
    this.datePostPayment = new Date();
    this.dateReceivedPayment = new Date();
  }

  selectInsurance(event: Event) {
    event.stopPropagation();
    //console.log('selectInsurance: ', this.isSelectingInsurace);
    if (this.isSelectingInsurace)
      return;
    this.isSelectingInsurace = true;

    const mappedInsuranceList = this.insuranceCompanyList.map(a => ({
      ...a,
      InsuranceType: this.getInsuranceTypeLabel(a.InsuranceOrder)
    }));

    const dialogRef = this.dialog.open(TdoSelectDialogComponent, {
      data: {
        dataSource: mappedInsuranceList,
        tableTitle: 'Select Insurance Company',
        columnDefinitions: [['Insurance Name', 'OrganizationName', true], ['Type', 'InsuranceType', false]],
        isSearchable: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.isSelectingInsurace = false;
      //console.log(' selectInsurance result', result);
      // return result
      if (result) {
        // select insurance
        this.selectedInsuranceCompany = result;
        this.LoadClaimsForInsurance();
      }
    }, err => {
      console.error('selectInsurance error', err);
    });
  }

  getInsuranceTypeLabel(order: number): string {
    if (order === 0) return 'Primary';
    if (order !== 0) return 'Secondary';
    return '';
  }

  get selectedInsuranceDisplayName(): string {
    if (!this.selectedInsuranceCompany) return '';
    const type = this.getInsuranceTypeLabel(this.selectedInsuranceCompany.InsuranceOrder);
    return type ? `${this.selectedInsuranceCompany.OrganizationName} (${type})` : this.selectedInsuranceCompany.OrganizationName;
  }

  getInsuranceDocuments() {
    const promise = new Promise((resolve, reject) => {
      this.fileService.getInsuranceDocuments(this.currentPatientID, this.currentARPayment?.PaymetnID ?? Constants.emptyGuid)
        .subscribe({ next: resolve, error: reject });
    });
    return promise;
  }

}
